import React, { useMemo } from 'react'
import { useAtomValue } from 'jotai'
import { Sheet } from '@node-space/ui-components'
import { massPayoutContactActionAtom } from 'pages/Contacts/atoms/contactAtoms'
import { MassPayoutContactSearch } from 'pages/MassPayouts/pages/MassPayoutContactSearch'
import { MassPayoutActionIds } from 'types/atoms/atom.massPayouts'

interface MassPayoutsSheetProps {
  isSheetOpen: boolean
  isNestedSheet?: boolean
}

export const MassPayoutsSheets = ({
  isSheetOpen,
  isNestedSheet = false,
}: MassPayoutsSheetProps) => {
  const massPayoutContactAction = useAtomValue(massPayoutContactActionAtom)

  const { onBack, onClose, header, subHeader } = massPayoutContactAction || {}

  const sheetContent = useMemo(() => {
    if (!massPayoutContactAction?.actionId) return null

    if (massPayoutContactAction.actionId === MassPayoutActionIds.MASSPAYOUTS) {
      return <MassPayoutContactSearch />
    }
  }, [massPayoutContactAction])

  return (
    <Sheet
      header={header}
      onBack={onBack}
      isOpen={isSheetOpen}
      onClose={onClose}
      subHeader={subHeader}
      isNestedSheet={isNestedSheet}
    >
      {sheetContent}
    </Sheet>
  )
}
